const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const fmt12 = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")}${h < 12 ? "am" : "pm"}`;
};

export const ClosingHoursSummary = ({ hours }) => {
  if (!hours || hours.every((h) => !h)) return <div className="text-[11px] text-amber-700 mt-2">No closing hours set (kiosk closing is off)</div>;
  return (
    <div className="mt-2 text-[11px] font-mono text-[color:var(--ups-subtext)]" data-testid="store-closing-summary">
      Closes: {DAYS.map((d, i) => `${d} ${hours[i] ? fmt12(hours[i]) : "closed"}`).join(" · ")}
    </div>
  );
};

export const ClosingHoursEditor = ({ hours, onChange }) => {
  const h = hours && hours.length === 7 ? hours : Array(7).fill(null);
  const set = (i, v) => onChange(h.map((x, j) => (j === i ? v : x)));
  return (
    <div className="sm:col-span-2" data-testid="store-closing-hours">
      <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[color:var(--ups-subtext)]">Closing time (kiosk closing opens 30 min before)</span>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-1">
        {DAYS.map((d, i) => (
          <div key={d} className="flex items-center gap-1.5 text-[12px]">
            <span className="w-8 font-bold">{d}</span>
            {h[i] ? (
              <>
                <input type="time" value={h[i]} onChange={(e) => set(i, e.target.value || null)} className="input-swiss px-1 py-1 rounded-sm text-[12px] w-[96px]" data-testid={`store-close-${i}`} />
                <button type="button" onClick={() => set(i, null)} className="text-[10px] underline text-[color:var(--ups-subtext)]" data-testid={`store-close-off-${i}`}>closed</button>
              </>
            ) : (
              <button type="button" onClick={() => set(i, "19:00")} className="text-[11px] px-2 py-1 rounded-sm border border-dashed border-[color:var(--ups-border)] text-[color:var(--ups-subtext)]" data-testid={`store-close-on-${i}`}>Closed · set time</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
